/**
 * 判断当前是手机还是电脑，用于选择支付宝的收银台形态。
 *
 * 这个值必须**由前端算好再显式告诉后端**：Worker 只看请求本身分不出终端
 * （同一个 URL 既可能来自手机也可能来自电脑），而支付宝的两种产品是分开签约的
 * —— 电脑走 `alipay.trade.page.pay`，手机走 `alipay.trade.wap.pay`。
 * 传错的后果是手机打开电脑收银台（或反），用户看到的页面不适配。
 */

export type ClientType = 'pc' | 'mobile';

/** 粗指针 + 窄屏也算手机：UA 伪装/精简 UA 的浏览器的兜底。 */
function byPointer(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(pointer: coarse)').matches && window.innerWidth < 1024;
}

export function detectClientType(): ClientType {
  if (typeof navigator === 'undefined') return 'pc';

  // Chromium 的 UA-CH 最可靠，优先用它。
  const uaData = (navigator as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData;
  if (uaData !== undefined && typeof uaData.mobile === 'boolean') {
    return uaData.mobile || byPointer() ? 'mobile' : 'pc';
  }

  const ua = navigator.userAgent;
  const mobileUa = /Android|iPhone|iPod|iPad|HarmonyOS|Mobile|Windows Phone|BlackBerry|Opera Mini|IEMobile/i.test(
    ua,
  );
  // iPadOS 13+ 默认伪装成 macOS，用粗指针兜底。
  return mobileUa || byPointer() ? 'mobile' : 'pc';
}
